export const isProductive = (): boolean => {
  const devDomains = ['tdgrid.snimg1.com', 'td.snimg1.com', 'localhost'];
  return !devDomains.includes(window.location.hostname);
};
